import React from 'react';
import { MenuIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-127">
        <div className="flex items-center gap-8" data-id="element-128">
          <div className="text-blue-900 font-bold text-xl" data-id="element-129">mar.pt</div>
          <nav className="hidden md:flex items-center gap-6 text-sm" data-id="element-130">
            <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-131">
              Início
            </a>
            <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-132">
              Sobre o Mar
            </a>
            <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-133">
              Mar e Saúde
            </a>
            <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-134">
              Notícias
            </a>
          </nav>
        </div>
        <div className="flex items-center gap-4" data-id="element-135">
          <button className="text-gray-700 hover:text-blue-600 text-sm" data-id="element-136">
            Português
          </button>
          <button className="md:hidden" data-id="element-137">
            <MenuIcon className="w-6 h-6" data-id="element-138" />
          </button>
        </div>
      </div>
    </header>;
}